// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__kwpAEiws6N{width:78px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/conversations/components/table/components/rows/conversationRow/components/rowCells/actions/conversationsTableActions.module.scss"],"names":[],"mappings":"AAAA,uBACE,UAAA","sourcesContent":[".container {\n  width: 78px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__kwpAEiws6N`
};
export default ___CSS_LOADER_EXPORT___;
